import { render, staticRenderFns } from "./lahlouh.vue?vue&type=template&id=175d451c&scoped=true&v-once=true"
import script from "./lahlouh.vue?vue&type=script&lang=js"
export * from "./lahlouh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d451c",
  null
  
)

export default component.exports